module.exports = __webpack_public_path__ + "static/media/camera-icon.c3732617.svg";